import type { CheckoutDataDTO, PersonalDetailsClientDTO, SessionInfoDTO } from './dto-client'
import type { PaymentData } from './PaymentData'
import { toPaymentData } from './PaymentData'
import type { PaymentPlan } from './PaymentPlan'

export interface CheckoutData {
    token: string
    sessionInfo?: SessionInfoDTO | null
    maturityPriceId?: number
    maturityGraceId?: number
    firstPaymentDate?: number
    authToken?: string
    personalDetails?: PersonalDetailsClientDTO | null
    paymentData?: PaymentData | null
    isVerified?: boolean
    isInStore?: boolean
    latestConsentsAccepted?: boolean
    paymentPlan?: PaymentPlan | null
    incomeLimit?: number
    vendorKnown?: boolean
    vendorName?: string
    returnUrl?: string
    pendingApproval?: boolean
    applicationApprovalType?: string
    vendorRequestType?: string
    vendorPackageDescription?: string
    customerLanguage?: string
    graceEnabled?: boolean
    insuranceEnabled?: boolean
    insuranceRatePercent?: number
    isInsuranceEnabledSelected?: boolean
    rbpEnabled?: boolean
    upsellEnabled?: boolean
}

/**
 * Maps CheckoutDataDTO to the normalized CheckoutData. Wraps nested paymentData
 * and paymentPlan, passes session/personal details through, and derives
 * `insuranceEnabled` from a positive insurance rate. Replaces the former
 * CheckoutData model class.
 */
export const toCheckoutData = (data: CheckoutDataDTO): CheckoutData => ({
    token: data.token,
    sessionInfo: data.sessionInfo ?? null,
    maturityPriceId: data.maturityPriceId,
    maturityGraceId: data.maturityGraceId,
    firstPaymentDate: data.firstPaymentDate,
    authToken: data.authToken,
    personalDetails: data.personalDetails ?? null,
    paymentData: data.paymentData ? toPaymentData(data.paymentData) : null,
    isVerified: data.isVerified,
    isInStore: data.isInStore,
    latestConsentsAccepted: data.latestConsentsAccepted,
    paymentPlan: data.paymentPlan ?? null,
    incomeLimit: data.incomeLimit,
    vendorKnown: data.vendorKnown,
    vendorName: data.vendorName,
    returnUrl: data.returnUrl,
    pendingApproval: data.pendingApproval,
    applicationApprovalType: data.applicationApprovalType,
    vendorRequestType: data.vendorRequestType,
    vendorPackageDescription: data.vendorPackageDescription,
    customerLanguage: data.customerLanguage,
    graceEnabled: data.graceEnabled,
    insuranceRatePercent: data.insuranceRatePercent,
    insuranceEnabled: Boolean(data.insuranceRatePercent && data.insuranceRatePercent > 0),
    isInsuranceEnabledSelected: data.isInsuranceEnabledSelected,
    rbpEnabled: data.rbpEnabled,
    upsellEnabled: data.upsellEnabled,
})
